import { UpdateUserData } from "../../Utils/updateUserData";

export function EmailUpdatesSignUp() {
    UpdateUserData("CanEmail", true)
}
